class GeolocationModal extends DialogModal {
  constructor() {
    super();
    this.cookieName = 'pxg_location';
    this.cookieDuration = 180; // days
    this.defaultHeading = '';
    this.dialog.addEventListener('close', this.close.bind(this));
  }

  connectedCallback() {
    this.showDialogIfNeeded();
    this.headingElm = this.querySelector('#location-heading');
    this.defaultHeading = this.headingElm.textContent;
  }

  close(event) {
    this.setLocationCookie();
    setTimeout(() => {
      if (this.defaultHeading !== '') this.headingElm.textContent = this.defaultHeading;
    }, 250);
  }

  updateLocationHeading() {
    this.headingElm.textContent = this.headingElm.getAttribute('data-location-help-text');
  }

  updateLocationList(local) {
    const locationItem = this.querySelector(`#location-${local}`);
    if (locationItem) locationItem.parentElement.prepend(locationItem);
  }

  /**
   * @param {string} country - The country to set the cookie to (US, CA, JP, KR, GB)
   */
  setLocationCookie(country = window.Shopify.country) {
    const date = new Date();
    date.setTime(date.getTime() + this.cookieDuration * 24 * 60 * 60 * 1000);
    document.cookie = `${this.cookieName}=${country};expires=${date.toUTCString()};path=/`;
  }

  /**
   * @returns {string | null}
   */
  getLocationCookie() {
    const geolocationCookie = document.cookie.split('; ').find((row) => row.startsWith(`${this.cookieName}=`));
    return geolocationCookie ? geolocationCookie.split('=')[1] : null;
  }

  /**
   * @returns {string | null}
   */
  getLocationFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('set-location');
  }

  /**
   * [Detect and set a visitor’s optimal localization](https://shopify.dev/docs/storefronts/themes/markets/localization-discovery)
   * @returns {string | null} The country code (US, CA, JP, KR, GB)
   */
  async getLocationFromShopify() {
    try {
      const response = await fetch(
        window.Shopify.routes.root +
          'browsing_context_suggestions.json' +
          '?country[enabled]=true' +
          `&country[exclude]=${window.Shopify.country}` +
          '&language[enabled]=true' +
          `&language[exclude]=${window.Shopify.language}`,
      );
      if (!response.ok) {
        console.error(`Geolocation response not ok: ${response.status}`);
        return null;
      }
      const data = await response.json();
      return data?.detected_values?.country?.handle || null;
    } catch (err) {
      console.error('Failed to get geolocation data:', err);
      return null;
    }
  }

  async showDialogIfNeeded() {
    const locationCookie = this.getLocationCookie();
    const locationFromUrl = this.getLocationFromUrl();

    // Location set, nothing else to do.
    if (locationCookie) return;

    // If location set from url, nothing else to do
    if (locationFromUrl) {
      this.setLocationCookie(locationFromUrl);
      return;
    }

    // No location set, get country from geolocation.
    const usersLocation = await this.getLocationFromShopify();
    if (usersLocation === window.Shopify.country || usersLocation === 'AE') {
      // Location matches shop country, set the cookie so we don't have to do this again.
      this.setLocationCookie(usersLocation);
      return;
    }

    this.updateLocationHeading();
    this.updateLocationList(usersLocation);
    this.show();
  }
}

customElements.define('geolocation-modal', GeolocationModal);
